import { SnackbarProvider, SnackbarProviderProps } from "notistack";
import { isAbortedRequestError } from "@/utils";

/**
 * Enhanced NotificationProvider that intercepts and filters out harmless aborted
 * network requests across all snackbars (e.g., when a user navigates between pages
 * before a GraphQL query finishes loading).
 */
export class NotificationProvider extends SnackbarProvider {
  constructor(props: SnackbarProviderProps) {
    super(props);
    const originalEnqueue = this.enqueueSnackbar;
    const safeEnqueue = (messageOrOptions: any, optsOrUndefined?: any) => {
      const message =
        typeof messageOrOptions === "object" && messageOrOptions !== null
          ? messageOrOptions.message
          : messageOrOptions;

      if (isAbortedRequestError(message)) {
        return null as any;
      }
      return originalEnqueue.call(this, messageOrOptions, optsOrUndefined);
    };

    this.enqueueSnackbar = safeEnqueue;
    if (this.state && (this.state as any).contextValue) {
      (this.state as any).contextValue.enqueueSnackbar = safeEnqueue;
    }
  }
}
